var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPlus = function SvgPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 21"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "var(--colors-brand)",
    fillRule: "evenodd",
    d: "m10.415 3.846.108.006a.928.928 0 0 1 .819.921v4.393h4.394c.475 0 .867.359.92.82l.007.108-.006.108a.929.929 0 0 1-.921.82l-4.395-.001v4.394a.926.926 0 0 1-.818.92l-.109.007-.108-.006a.928.928 0 0 1-.818-.92l-.001-4.396H5.094a.926.926 0 0 1-.921-.818l-.006-.108.006-.109a.926.926 0 0 1 .92-.818l4.394-.001V4.773c0-.475.359-.867.82-.92l.108-.007z"
  })));
};

export default SvgPlus;